import { Level } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import Theme, { ThemeType } from '../../theme';
import { mappedSkillLevelIcons } from '../../ui/components/SkillLevelList';
import { getSkillLevelText } from '../../utils';
import { defaultScale } from '../../utils/scaling';
import { ButtonMargin, SelectionContainer } from './SelectionContainer';

interface IProps {
  skillLevel: Level | null;
  theme: ThemeType;
  width?: number | string;
  height?: number | string;
  maxWidth?: number | string;
  verticalStack?: boolean;

  onPress(skillLevel: Level): Promise<void>;
}

export const SkillLevelSelection: FunctionComponent<IProps> = ({
                                                                 onPress,
                                                                 skillLevel,
                                                                 theme = ThemeType.light,
                                                                 width,
                                                                 height,
                                                                 maxWidth,
                                                                 verticalStack = false,
                                                               }) => {
  return (
    <View style={[styles.container, { flexDirection: verticalStack ? 'column' : 'row' }]}>
      <SkillLevel
        onPress={onPress}
        currentLevel={skillLevel}
        skillLevel={Level.Beginner}
        theme={theme}
        width={verticalStack ? '100%' : width}
        height={height}
        maxWidth={verticalStack ? '100%' : maxWidth}
        verticalStack={verticalStack}
      />
      <SkillLevel
        style={{ marginHorizontal: verticalStack ? 0 : ButtonMargin, marginVertical: verticalStack ? ButtonMargin : 0 }}
        onPress={onPress}
        currentLevel={skillLevel}
        skillLevel={Level.Basic}
        theme={theme}
        width={verticalStack ? '100%' : width}
        height={height}
        maxWidth={verticalStack ? '100%' : maxWidth}
        verticalStack={verticalStack}
      />
      <SkillLevel
        onPress={onPress}
        currentLevel={skillLevel}
        skillLevel={Level.Intermediate}
        theme={theme}
        width={verticalStack ? '100%' : width}
        height={height}
        maxWidth={verticalStack ? '100%' : maxWidth}
        verticalStack={verticalStack}
      />
    </View>
  );
};

const SkillLevel = ({ currentLevel, skillLevel, onPress, style, theme, width = 110, height = 110, maxWidth, verticalStack = false }) => {
  const isSelected = currentLevel === skillLevel;
  const selectedIconColor = isSelected
    ? theme === ThemeType.light ? Theme.WHITE : Theme.BLACK
    : theme === ThemeType.light ? Theme.BLACK : Theme.WHITE;
  return (
    <SelectionContainer
      width={defaultScale(width)}
      height={defaultScale(height)}
      maxWidth={maxWidth}
      title={getSkillLevelText[skillLevel]}
      titleStyle={[styles.title, { color: selectedIconColor }, verticalStack && styles.titleVerticalStack]}
      isSelected={isSelected}
      style={style}
      onPress={() => onPress(skillLevel)}
      theme={theme}
      verticalStack={verticalStack}
      icon={(
        <View style={[styles.iconContainer, verticalStack && styles.iconContainerVerticalStack]}>
          {mappedSkillLevelIcons[skillLevel](selectedIconColor)}
        </View>
      )}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
  },
  title: {
    ...Theme.textStyle.bodyCopyBold,
    paddingTop: defaultScale(10),
    textAlign: 'center',
  },
  titleVerticalStack: {
    ...Theme.textStyle.heading,
    marginLeft: defaultScale(15),
    color: Theme.GREY_DARK,
  },
  iconContainer: {
    width: defaultScale(50),
    height: defaultScale(20),
    alignItems: 'center',
  },
  iconContainerVerticalStack: {
    marginRight: defaultScale(30),
  },
});
